/* eslint-disable jira/filename-case */
import React from 'react';

/**
 * Add the ?jfeLocalWhyDidYouRender=true query param to your page to enable why-did-you-render.
 * Usage: see https://github.com/welldone-software/why-did-you-render
 */
if (process.env.NODE_ENV === 'development') {
	if (
		typeof window !== 'undefined' &&
		new URLSearchParams(window.location.search).get('jfeLocalWhyDidYouRender') === 'true'
	) {
		// oxlint-disable-next-line typescript/no-require-imports
		const whyDidYouRender = require('@welldone-software/why-did-you-render');
		whyDidYouRender(React, {
			/**
			 * breaks the entire app if set to true, most likely due to the way JFE is set up,
			 * but actual underlying cause unknown as of yet.
			 */
			trackHooks: false,
			/**
			 * can produce a lot of noise but you can enable it if you like
			 */
			trackAllPureComponents: false,
		});
	}
}
